import { formatDate } from '@angular/common';
import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Route, Router } from '@angular/router';
import { AppointmentFilter } from 'app/models/AppointmentFilter';
import { AppointmentListResource } from 'app/models/AppointmentListResource';
import { AppointmentStatusListResource } from 'app/models/AppointmentStatusListResource';
import { AppointmentStatusResource } from 'app/models/AppointmentStatusResource';
import { DepartmentListResource } from 'app/models/DepartmentListResource';
import { DepartmentResource } from 'app/models/DepartmentResource';
import { UtilsService } from 'app/services/utils.service';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'vbn-appointments-list',
  templateUrl: './appointments-list.component.html',
  styleUrls: ['./appointments-list.component.scss']
})
export class AppointmentsListComponent implements OnInit {

  userEmail: string;
  departmentList: DepartmentListResource;

  selectedClient = (atob(localStorage.getItem("_sc")) === atob(null)) ? null : atob(localStorage.getItem("_sc"));
  clientEmail = (this.selectedClient == null) ? "" : "?clientEmail=" + this.selectedClient

  errorMessage: any;

  selectedDepartmentID: number=0;

  appointmentFilter: AppointmentFilter;

  appointmentListResource: AppointmentListResource;

  currentLanguage = localStorage.getItem("vbn-language");

  roleId = parseInt(localStorage.getItem("_roleId"));

  appointmentStatusListResource: AppointmentStatusListResource;
  pageNumber: number;
  configPagination: any;

  createdDate: Date;

  dateFormat: string = "yyyy-MM-dd";
  locale: string = "en-US";

  selectedStatus: string = '0';
  isOnResponsive: boolean = false;

  disabledFilters: boolean = true;

  addressParams: any;
  constructor(private service: UtilsService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.departmentList = new DepartmentListResource();
    this.departmentList.departmentList = [];
    this.appointmentFilter = new AppointmentFilter();
    this.appointmentListResource = new AppointmentListResource()
    this.appointmentListResource.appointmentList = [];
    this.pageNumber = 1;
    this.appointmentStatusListResource = new AppointmentStatusListResource();
    this.appointmentStatusListResource.statusList = []
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const innerWidth = window.innerWidth;
    if (innerWidth <= 1300) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }
  }


  ngOnInit() {
    this.userEmail = this.service.currentUserEmail;
    this.getDepartmentList();
    this.getAppointmentStatus();

    if (innerWidth <= 1300) {
      this.isOnResponsive = true;
    }
    else {
      this.isOnResponsive = false;
    }

    this.activatedRoute.params.subscribe((params: Params) => {
      if ('json' in params) {
        this.addressParams = JSON.parse(atob(params['json']));
        console.log("aaaa", this.addressParams)
        if (this.addressParams.departmentID) {
          this.selectedDepartmentID = this.addressParams.departmentID
        } else {
          this.selectedDepartmentID = 0;
        }
        this.getAppointmentsList();
      }
    });
  }

  getDepartmentList() {
    this.service.get(`/admin/department/getAll${this.clientEmail}`)
      .subscribe(
        response => { this.departmentList = response },
        err => this.errorMessage = err
      )
  }

  getAppointmentStatus() {
    this.service.appointmentStatus$.subscribe(
      response => { this.appointmentStatusListResource = response },
      err => this.errorMessage = err
    )
  }


  onSelected(val: number) {
    this.selectedDepartmentID = Number(val);
    this.getAppointmentsList();
  }

  getAppointmentsList() {
    if (this.selectedDepartmentID == 0) {
      this.disabledFilters = true;
      this.appointmentListResource = new AppointmentListResource();
      this.appointmentListResource.appointmentList = [];
      return;
    } else {
      this.disabledFilters = false;
      this.appointmentFilter.departmentId = this.selectedDepartmentID;
      this.appointmentFilter.pageNumber = this.pageNumber;
      this.appointmentFilter.itemPerPage = 10;
      this.service.add(`/admin/appointment/getAllAppointmentsBy`, this.appointmentFilter)
        .subscribe(
          response => {
            this.appointmentListResource = response;
            this.configPagination = {
              cap: this.appointmentListResource.numberOfPages,
              start: this.pageNumber
            }
          },
          err => this.errorMessage = err
        )
    }

  }


  handlePageChange(event) {
    this.pageNumber = event
    this.getAppointmentsList();
  }

  onSelectedStatus(val) {
    this.pageNumber = 1;
    this.appointmentFilter.appointmentStatus = new AppointmentStatusResource();
    this.appointmentFilter.appointmentStatus.value = val;
    this.getAppointmentsList();
  }

  onCalendarSelection(day) {
    let selectedDate = formatDate(day, this.dateFormat, this.locale);

    this.appointmentFilter.createdDate = new Date(selectedDate);
    this.getAppointmentsList();
  }

  resetFilter() {
    this.appointmentFilter = new AppointmentFilter();
    this.selectedStatus = '0';
    this.getAppointmentsList();
  }

  applyFilter() {
    this.pageNumber = 1;
    this.getAppointmentsList();
  }

  goToDetails(id) {
    this.router.navigate(['/add-edit-appointments/' + btoa('{"appointmentId":"' + id + '"}')])
  }

  showResponsiveDetails(id) {
    const width = window.innerWidth;
    if (width <= 1300) {
      for (let i = 0; i < this.appointmentListResource.appointmentList.length; i++) {
        if (this.appointmentListResource.appointmentList[i].id === id) {
          this.appointmentListResource.appointmentList[i].showDetailsOnResponsive = !this.appointmentListResource.appointmentList[i].showDetailsOnResponsive;
        }
        else {
          this.appointmentListResource.appointmentList[i].showDetailsOnResponsive = false;
        }
      }
    }
    else {
      return;
    }

  }
}
